@if (orderWindow) {
  <ng-container
    *ngTemplateOutlet="
      orderWindow.active
        ? open
        : orderWindow?.upcoming
          ? upcoming
          : historicalMode
    "
  >
  </ng-container>
} @else {
  @if (statistics?.ow_upcoming) {
    <div class="header__callout">
      Countdown To {{ statistics.ow_upcoming.label }} &nbsp; | &nbsp; Opens
      {{ statistics.ow_upcoming.start_at.format('MMMM D, YYYY') }}
    </div>
  }
}

<ng-template #open>
  <div class="header__callout order-window open" id="callout-open-window">
    <span
      >{{ orderWindow.label }} &nbsp; | &nbsp; open &nbsp; | &nbsp;{{
        formattedDates
      }}</span
    >
    <button
      id="callout-view-calendar-btn"
      class="btn btn-link underline btn--calendar"
      (click)="showCalendar()"
    >
      View Calendar
      <img
        src="/assets/img/icons/calendar_white.png"
        alt="calendar icon"
        class="ms-2"
      />
    </button>
  </div>
</ng-template>

<ng-template #historicalMode>
  <div
    class="header__callout order-window inactive"
    id="callout-historical-window"
  >
    <span
      >{{ orderWindow.label }} &nbsp; | &nbsp; closed &nbsp; | &nbsp;
      {{ formattedDates }}</span
    >
    <button
      id="callout-historical-view-calendar-btn"
      class="btn btn-link underline btn--calendar"
      (click)="showCalendar()"
    >
      View Calendar
      <img
        src="/assets/img/icons/calendar_white.png"
        alt="calendar icon"
        class="ms-2"
      />
    </button>
  </div>
</ng-template>

<ng-template #upcoming>
  <div
    class="header__callout order-window upcoming"
    id="callout-upcoming-window"
  >
    <span
      >{{ orderWindow.label }} &nbsp; | &nbsp; upcoming &nbsp; | &nbsp;
      {{ formattedDates }}</span
    >
    <button
      id="callout-upcoming-view-calendar-btn"
      class="btn btn-link underline btn--calendar"
      (click)="showCalendar()"
    >
      View Calendar
      <img
        src="/assets/img/icons/calendar_white.png"
        alt="calendar icon"
        class="ms-2"
      />
    </button>
  </div>
</ng-template>
